// Maximum number of words allowed when sending notes to AI analysis
export const MAX_ANALYSIS_WORDS = 4096
